import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDualSided = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 322,
	height: 175,
	viewBox: "0 0 322 175",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 322,
			height: 175,
			rx: 8,
			fill: "#F2F2F2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.6161,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.5,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.616,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 19.5,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 108.998,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 108.998,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 212.03,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 212.03,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64.3059,
			y: 21.5,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64.3059,
			y: 100.871,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 131.5,
			y: 21.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 131.5,
			y: 100.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.5,
			y: 21.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 172.5,
			y: 100.5,
			width: 17,
			height: 53,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 234.72,
			y: 21.5,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 234.72,
			y: 100.871,
			width: 21.6898,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86.3082,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 86.3082,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 189.34,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 189.34,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 256.722,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 279.123,
			y: 21.5,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 256.722,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 279.123,
			y: 100.871,
			width: 22.3774,
			height: 52.629,
			fill: "#E5E7E9",
			stroke: "#D0D0D0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 100L153 99.9981",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149 100L301 100",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 75L148.5 75",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M173 75L301 75",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149 101L149 22",
			stroke: "#0FC417",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.8861 48.1721L85.9813 73.914L98.0138 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 48.1721L42.0952 73.914L54.1277 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72.8477 126.47L86.9429 100.729L98.9753 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 126.47L42.0952 100.729L54.1277 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.578 48.1721L130.673 73.914L142.706 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M117.54 126.47L131.635 100.729L141.5 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.5 126.47L189.83 100.729L201.863 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M179.5 48.1721L188.869 73.914L200.901 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.929 126.47L235.024 100.729L247.056 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265 126.47L279.095 100.729L291.128 126.47",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.929 48.1721L235.024 73.914L247.056 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M266 48.1721L280.095 73.914L292.128 48.1721",
			stroke: "#E20005"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.503 74H147.503",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 74L86 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.197 74H189.197",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236 74H280",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.081 102L172.081 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148 102L148 74",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.503 101H148.503",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.197 101L189.197 101",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235 101L280 101",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 101L87 101",
			stroke: "#E00E13"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M149.8 71C149.952 71 150.084 71.0934 150.152 71.2358L151.929 74.7472C151.977 74.8179 152.001 74.9075 152.001 75.0009C152.001 75.0943 151.977 75.183 151.929 75.2547L150.152 78.766C150.118 78.8377 150.068 78.8972 150.006 78.9387C149.944 78.9802 149.873 79.0019 149.801 79.0019H146.2C146.048 79.0019 145.916 78.9085 145.848 78.766L144.072 75.2538C144.024 75.183 144 75.0934 144 75C144 74.9066 144.024 74.8179 144.072 74.7462L145.848 71.2358C145.916 71.0934 146.049 71 146.201 71H149.801H149.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M151.351 74.8198L149.843 71.8387C149.786 71.7179 149.674 71.6387 149.544 71.6387H146.488C146.359 71.6387 146.247 71.7179 146.189 71.8387L144.681 74.8198C144.64 74.8802 144.62 74.9557 144.62 75.0349C144.62 75.1142 144.64 75.1896 144.681 75.25L146.189 78.2311C146.247 78.3519 146.359 78.4311 146.488 78.4311H149.544C149.606 78.4311 149.667 78.4132 149.719 78.3774C149.772 78.3425 149.815 78.2915 149.843 78.2311L151.351 75.25C151.392 75.1896 151.412 75.1142 151.412 75.0349C151.412 74.9557 151.392 74.8802 151.351 74.8198ZM146.588 72.2047H147.934L147.35 73.333L145.8 76.3302L145.149 75.0453L146.588 72.2047ZM149.444 77.8858H146.588L145.956 76.6396H150.075L149.443 77.8858H149.444ZM150.232 76.3302L148.098 72.2047H149.443L150.883 75.0453L150.231 76.3302H150.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M174.8 97C174.952 97 175.084 97.0934 175.152 97.2358L176.929 100.747C176.977 100.818 177.001 100.908 177.001 101.001C177.001 101.094 176.977 101.183 176.929 101.255L175.152 104.766C175.118 104.838 175.068 104.897 175.006 104.939C174.944 104.98 174.873 105.002 174.801 105.002H171.2C171.048 105.002 170.916 104.908 170.848 104.766L169.072 101.254C169.024 101.183 169 101.093 169 101C169 100.907 169.024 100.818 169.072 100.746L170.848 97.2358C170.916 97.0934 171.049 97 171.201 97H174.801H174.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M176.351 100.82L174.843 97.8387C174.786 97.7179 174.674 97.6387 174.544 97.6387H171.488C171.359 97.6387 171.247 97.7179 171.189 97.8387L169.681 100.82C169.64 100.88 169.62 100.956 169.62 101.035C169.62 101.114 169.64 101.19 169.681 101.25L171.189 104.231C171.247 104.352 171.359 104.431 171.488 104.431H174.544C174.606 104.431 174.667 104.413 174.719 104.377C174.772 104.342 174.815 104.292 174.843 104.231L176.351 101.25C176.392 101.19 176.412 101.114 176.412 101.035C176.412 100.956 176.392 100.88 176.351 100.82ZM171.588 98.2047H172.934L172.35 99.333L170.8 102.33L170.149 101.045L171.588 98.2047ZM174.444 103.886H171.588L170.956 102.64H175.075L174.443 103.886H174.444ZM175.232 102.33L173.098 98.2047H174.443L175.883 101.045L175.231 102.33H175.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip2_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M87.8 71C87.952 71 88.0836 71.0934 88.1524 71.2358L89.9287 74.7472C89.9771 74.8179 90.0008 74.9075 90.0008 75.0009C90.0008 75.0943 89.9771 75.183 89.9287 75.2547L88.1524 78.766C88.1184 78.8377 88.0684 78.8972 88.0064 78.9387C87.9444 78.9802 87.8731 79.0019 87.8009 79.0019H84.2C84.048 79.0019 83.9164 78.9085 83.8476 78.766L82.0722 75.2538C82.0238 75.183 82 75.0934 82 75C82 74.9066 82.0238 74.8179 82.0722 74.7462L83.8484 71.2358C83.9164 71.0934 84.0488 71 84.2008 71H87.8009H87.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M89.3513 74.8198L87.8433 71.8387C87.7856 71.7179 87.6735 71.6387 87.5445 71.6387H84.4878C84.3587 71.6387 84.2467 71.7179 84.1889 71.8387L82.681 74.8198C82.6402 74.8802 82.6198 74.9557 82.6198 75.0349C82.6198 75.1142 82.6402 75.1896 82.681 75.25L84.1889 78.2311C84.2467 78.3519 84.3587 78.4311 84.4878 78.4311H87.5445C87.6056 78.4311 87.6667 78.4132 87.7194 78.3774C87.772 78.3425 87.8153 78.2915 87.8433 78.2311L89.3513 75.25C89.3921 75.1896 89.4124 75.1142 89.4124 75.0349C89.4124 74.9557 89.3921 74.8802 89.3513 74.8198ZM84.588 72.2047H85.9338L85.3505 73.333L83.8 76.3302L83.1488 75.0453L84.588 72.2047ZM87.4443 77.8858H84.588L83.9563 76.6396H88.0751L87.4434 77.8858H87.4443ZM88.2322 76.3302L86.0976 72.2047H87.4434L88.8826 75.0453L88.2314 76.3302H88.2322Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip3_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M87.8 97C87.952 97 88.0836 97.0934 88.1524 97.2358L89.9287 100.747C89.9771 100.818 90.0008 100.908 90.0008 101.001C90.0008 101.094 89.9771 101.183 89.9287 101.255L88.1524 104.766C88.1184 104.838 88.0684 104.897 88.0064 104.939C87.9444 104.98 87.8731 105.002 87.8009 105.002H84.2C84.048 105.002 83.9164 104.908 83.8476 104.766L82.0722 101.254C82.0238 101.183 82 101.093 82 101C82 100.907 82.0238 100.818 82.0722 100.746L83.8484 97.2358C83.9164 97.0934 84.0488 97 84.2008 97H87.8009H87.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M89.3513 100.82L87.8433 97.8387C87.7856 97.7179 87.6735 97.6387 87.5445 97.6387H84.4878C84.3587 97.6387 84.2467 97.7179 84.1889 97.8387L82.681 100.82C82.6402 100.88 82.6198 100.956 82.6198 101.035C82.6198 101.114 82.6402 101.19 82.681 101.25L84.1889 104.231C84.2467 104.352 84.3587 104.431 84.4878 104.431H87.5445C87.6056 104.431 87.6667 104.413 87.7194 104.377C87.772 104.342 87.8153 104.292 87.8433 104.231L89.3513 101.25C89.3921 101.19 89.4124 101.114 89.4124 101.035C89.4124 100.956 89.3921 100.88 89.3513 100.82ZM84.588 98.2047H85.9338L85.3505 99.333L83.8 102.33L83.1488 101.045L84.588 98.2047ZM87.4443 103.886H84.588L83.9563 102.64H88.0751L87.4434 103.886H87.4443ZM88.2322 102.33L86.0976 98.2047H87.4434L88.8826 101.045L88.2314 102.33H88.2322Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip4_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M236.8 71C236.952 71 237.084 71.0934 237.152 71.2358L238.929 74.7472C238.977 74.8179 239.001 74.9075 239.001 75.0009C239.001 75.0943 238.977 75.183 238.929 75.2547L237.152 78.766C237.118 78.8377 237.068 78.8972 237.006 78.9387C236.944 78.9802 236.873 79.0019 236.801 79.0019H233.2C233.048 79.0019 232.916 78.9085 232.848 78.766L231.072 75.2538C231.024 75.183 231 75.0934 231 75C231 74.9066 231.024 74.8179 231.072 74.7462L232.848 71.2358C232.916 71.0934 233.049 71 233.201 71H236.801H236.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M238.351 74.8198L236.843 71.8387C236.786 71.7179 236.674 71.6387 236.544 71.6387H233.488C233.359 71.6387 233.247 71.7179 233.189 71.8387L231.681 74.8198C231.64 74.8802 231.62 74.9557 231.62 75.0349C231.62 75.1142 231.64 75.1896 231.681 75.25L233.189 78.2311C233.247 78.3519 233.359 78.4311 233.488 78.4311H236.544C236.606 78.4311 236.667 78.4132 236.719 78.3774C236.772 78.3425 236.815 78.2915 236.843 78.2311L238.351 75.25C238.392 75.1896 238.412 75.1142 238.412 75.0349C238.412 74.9557 238.392 74.8802 238.351 74.8198ZM233.588 72.2047H234.934L234.35 73.333L232.8 76.3302L232.149 75.0453L233.588 72.2047ZM236.444 77.8858H233.588L232.956 76.6396H237.075L236.443 77.8858H236.444ZM237.232 76.3302L235.098 72.2047H236.443L237.883 75.0453L237.231 76.3302H237.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip5_247_413)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M236.8 96C236.952 96 237.084 96.0934 237.152 96.2358L238.929 99.7472C238.977 99.8179 239.001 99.9075 239.001 100.001C239.001 100.094 238.977 100.183 238.929 100.255L237.152 103.766C237.118 103.838 237.068 103.897 237.006 103.939C236.944 103.98 236.873 104.002 236.801 104.002H233.2C233.048 104.002 232.916 103.908 232.848 103.766L231.072 100.254C231.024 100.183 231 100.093 231 100C231 99.9066 231.024 99.8179 231.072 99.7462L232.848 96.2358C232.916 96.0934 233.049 96 233.201 96H236.801H236.8Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M238.351 99.8198L236.843 96.8387C236.786 96.7179 236.674 96.6387 236.544 96.6387H233.488C233.359 96.6387 233.247 96.7179 233.189 96.8387L231.681 99.8198C231.64 99.8802 231.62 99.9557 231.62 100.035C231.62 100.114 231.64 100.19 231.681 100.25L233.189 103.231C233.247 103.352 233.359 103.431 233.488 103.431H236.544C236.606 103.431 236.667 103.413 236.719 103.377C236.772 103.342 236.815 103.292 236.843 103.231L238.351 100.25C238.392 100.19 238.412 100.114 238.412 100.035C238.412 99.9557 238.392 99.8802 238.351 99.8198ZM233.588 97.2047H234.934L234.35 98.333L232.8 101.33L232.149 100.045L233.588 97.2047ZM236.444 102.886H233.588L232.956 101.64H237.075L236.443 102.886H236.444ZM237.232 101.33L235.098 97.2047H236.443L237.883 100.045L237.231 101.33H237.232Z",
				fill: "#E1373B"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(144 71)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(169 97)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(82 71)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip3_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(82 97)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip4_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(231 71)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip5_247_413",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 8,
					height: 8,
					fill: "white",
					transform: "translate(231 96)"
				})
			})
		] })
	]
});
export default SvgDualSided;
